import axiosNew from "./axiosNew";
import { decryptdata, encryptdata } from "../../utils/encryptDecrypt";
import axiosPublic from "./axiosPublic";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
console.log("SECRET_KEY (NEW API)", SECRET_KEY);

export const getApiNew = (url) =>
  new Promise((resolve, reject) => {
    axiosNew
      .get(url)
      .then((response) => {
        if (response.data && response.data.error)
          reject(response.data.error);
        else resolve(response.data);
      })
      .catch((e) => reject(e));
  });

export const postApiNew = (url, data) =>
  new Promise((resolve, reject) => {
    // const datas = encryptdata(data);
    axiosNew
      .post(url, data)
      .then((response) => {
        if (response.data && response.data.error)
          reject(response.data.error);
        else resolve(response.data);
      })
      .catch((e) => reject(e));
  });

export const putApiNew = (url, data) =>
  new Promise((resolve, reject) => {
    // const datas = encryptdata(data);
    axiosNew
      .put(url, { data: data })
      .then((response) => {
        if (response.data && response.data.error)
          reject(response.data.error);
        else resolve(response.data);
      })
      .catch((e) => reject(e));
  });

export const deleteApiNew = (url) =>
  new Promise((resolve, reject) => {
    axiosNew
      .delete(url)
      .then((response) => {
        if (response.data && response.data.error)
          reject(response.data.error);
        else resolve(response.data);
      })
      .catch((e) => reject(e));
  });


export const getApiPublic = (url) =>
  new Promise((resolve, reject) => {
    axiosPublic
      .get(url)
      .then((response) => {
        if (response.data && response.data.error)
          reject(response.data.error);
        else resolve(response.data);
      })
      .catch((e) => reject(e));
  });
